import EditExpenses from '../../pages/Transactions/EditExpenses';
import { TransactionsController } from '../../controllers';
import { appStore, useStores } from '../../stores';
import { MimaToastUtil } from '../../components';
import { string, object, number } from 'yup';
import constant from '../../utils/constant';
import React, { useState } from 'react';
import { observer } from 'mobx-react';

const EditExpenseContainer = ({ closeModal }) => {
	const [openExpenseModal, setOpenExpenseModal] = useState(true);
	const [expenseSuccess, setExpenseSuccess] = useState(false);
	let {
		appStore: { loading },
	} = useStores();
	const getAddedExpenses = () => {
		setOpenExpenseModal(false);
		setExpenseSuccess(true);
	};

	const addNewExpense = () => {
		setOpenExpenseModal(true);
		setExpenseSuccess(false);
	};
	const validationSchema = () => {
		return object({
			expenseCategory: string().required('Expense Category is required'),
			transactionAmount: number()
				.required()
				.min(1, 'The minimum transaction amount should be 1'),
			narration: string().required('Narration is required'),
			paidDate: string().required('Paid date is required'),
			paymentMethod: string().required('Payment Method is required'),
		});
	};

	const onSubmit = async payload => {
		appStore.setLoading(true);
		const { status, errorMessage } = await TransactionsController.postExpense(
			payload
		);
		appStore.setLoading(false);
		if (status === constant.Success) {
			MimaToastUtil.success({
				message: constant.Success,
			});
			return getAddedExpenses();
		}
		return MimaToastUtil.error({
			message: errorMessage,
		});
	};

	return (
		<EditExpenses
			closeModal={closeModal}
			onSubmit={onSubmit}
			validationSchema={validationSchema}
			loading={loading}
			openExpenseModal={openExpenseModal}
			expenseSuccess={expenseSuccess}
			addNewExpense={addNewExpense}
		/>
	);
};

export default observer(EditExpenseContainer);
